// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0f02672b","453":"00a3e115"}[chunkId] + ".chunk.js";
};